module.exports = __webpack_public_path__ + "img/Preguntas frecuentes 576px.73dbb9af.png";